import enterpriseServices, {
  CreateEnterpriseParams,
  EnterpriseInfoParams,
  EnterpriseListParams,
  EnterpriseRenewListParams,
  PaidRenewParams,
} from '@/services/enterpriseServices';
import { makeAutoObservable, action } from 'mobx';
import { makePersistable, isHydrated, isPersisting } from 'mobx-persist-store';

export default class EnterpriseStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true }); // this绑定当前Store
    makePersistable(this, {
      name: 'EnterpriseStore',
      properties: [],
      storage: window.localStorage,
    }).then(
      action((persistStore) => {
        // console.log('persistStore', persistStore.isHydrated);
      })
    );
  }

  get isHydrated() {
    return isHydrated(this);
  }

  get isPersisting() {
    return isPersisting(this);
  }

  // 获取企业列表
  async getEnterpriseList(params: EnterpriseListParams) {
    const res = await enterpriseServices.getEnterpriseList(params);
    return Promise.resolve(res);
  }

  // 批准企业
  async createEnterpriseInfo(params: CreateEnterpriseParams) {
    const res = await enterpriseServices.createEnterpriseInfo(params);
    return Promise.resolve(res);
  }

  // 获取企业相关信息
  async getEnterpriseBasicInfo(params: EnterpriseInfoParams) {
    const res = await enterpriseServices.getEnterpriseInfo(params);
    return Promise.resolve(res);
  }

  // 获取企业账号的订阅列表
  async getEnterpriseRenewList(params: EnterpriseRenewListParams) {
    const res = await enterpriseServices.getEnterpriseRenewList(params);
    return Promise.resolve(res);
  }

  // 确认企业订阅已支付
  async confirmPaidRenew(params: PaidRenewParams) {
    const res = await enterpriseServices.confirmPaidRenew(params);
    return Promise.resolve(res);
  }
}
